<template>
  <div id="stream">
    <div class="video-container" ref="videoContainer">
      <img v-if="!(youTubeId || hostedVideoUrl)" class="feed" :src="placeholderSrc" />
      <MediaItem v-if="youTubeId"  class="feed" :youTubeId="youTubeId" />
      <MediaItem v-if="hostedVideoUrl"  class="feed" :hostedVideoUrl="hostedVideoUrl" />
    </div>
  </div>
</template>

<script>
import MediaItem from "@/components/MediaItem.vue"

export default {
  name: "stream",
  components: {
    MediaItem,
  },
  props: {
    youTubeId: String,
    hostedVideoUrl: String,
    placeholderSrc: String
  }
}
</script>

<style lang="scss" scoped>
  .greysite #stream {
    .video-container {
      border-radius: 20px;
      border-bottom: 1px solid #9e9e9e;
      border-right: 1px solid #9e9e9e;
    }
  }
  #stream {
    display: flex;
    flex-flow: row-nowrap;
    justify-content: center;
    align-items: center;

    .video-container {
      position: relative;
      width: 100%;

      .feed {
        width: 100%;
        border-radius: 20px;
      }

      .overlay {
        display: flex;
        flex-flow: row nowrap;
        align-items: center;
        position: absolute;
        top: 0;
        right: 0;
        padding: 1em;
        background-color: $color-white;
        font-size: 15px;

        .where-we-at {
          .pill {
            display: inline-block;
            padding: 0.3em 1em;
            border-radius: 100px;
            text-transform: uppercase;
            color: $color-white;
            background: $color-red;
          }
        }

        .controls {
          padding-left: 1.5em;

          .control {
            display: inline-block;
            width: 1em;
            height: 1em;
            line-height: 1em;
            text-align: center;
            border-radius: 50%;
            border: solid 1px $color-grey-dark;
            color: $color-grey-dark;
            text-decoration: none;
          }
        }
      }
    }
  }
</style>
